import React, { useEffect, useRef, useState } from "react";
import { Accordion } from "react-bootstrap";
import PageBanner from "../components/PageBanner";
import Layouts from "../layouts/Layouts";
import { Grid, Typography, Box, Button } from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FiChevronsRight } from "react-icons/fi";
import { getDownloadURL, getStorage, listAll, ref } from "firebase/storage";
import { db, storage } from "../firebase";
import { useTranslation } from "react-i18next";
import { collection, getDocs } from "firebase/firestore";
import ReviewsSection from "../components/Reviews";

const About = () => {
  const [toggle, setToggle] = useState(1);
  const [imageUrls, setImageUrls] = useState({});
  const doctorsSectionRef = useRef(null);
  const reviewsSectionRef = useRef(null);

  const { t, i18n } = useTranslation();
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();

  const location = useLocation();
  useEffect(() => {
    if (location.state?.scrollToReviews && reviewsSectionRef.current) {
      reviewsSectionRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);
  console.log("IMAGES", imageUrls);

  useEffect(() => {
    const fetchImages = async () => {
      const storage = getStorage();
      const storageRef = ref(storage, "about");
      try {
        const result = await listAll(storageRef);

        const urls = await Promise.all(
          result.items.map(async (itemRef) => {
            const url = await getDownloadURL(itemRef);
            return { name: itemRef.name, url };
          })
        );

        const newImageUrls = {};
        urls.forEach((image) => {
          newImageUrls[image.name] = image.url;
        });

        setImageUrls(newImageUrls);
      } catch (error) {
        console.error("Error fetching images:", error);
      }
    };

    fetchImages();
  }, []);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "Users"));
        const userList = querySnapshot.docs.map((doc) => doc.data());
        setUsers(userList);
      } catch (error) {
        console.error("Error fetching users from Firestore:", error);
      }
    };
    fetchUsers();
  }, []);
  const handleServiceClick = (doctor) => {
    console.log("RECTS", doctor);
    navigate("/doctor", { state: { doctor } });
  };
  const scrollToDoctors = () => {
    if (doctorsSectionRef.current) {
      doctorsSectionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };
  const getTranslatedValue = (field, lang) => {
    if (!field) return "";
    return field[lang] || field["en"] || "";
  };
  return (
    <Layouts footer={2} noheader>
      <section className="about-section section-gap">
        <div className="container">
          <div className="row justify-content-lg-between justify-content-center align-items-center">
            <div className="col-lg-6 col-md-10">
              <div className="circle-image-gallery mb-md-50">
                <div className="row">
                  <div className="col-6 gallery-left">
                    <div
                      className="single-img wow fadeInLeft"
                      data-wow-delay="0.3s"
                    >
                      <img
                        // src={imageUrls["11.jpg"]}
                        src="assets/img/about/11.jpg"
                        alt="Dr. Lakdawala Eye Hospital"
                        style={{
                          height: "220px",
                          objectFit: "cover",
                          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        }}
                      />
                    </div>
                    <div
                      className="single-img wow fadeInRight"
                      data-wow-delay="0.4s"
                    >
                      <img
                        // src={imageUrls["22.jpeg"]}
                        src="assets/img/about/22.jpeg"
                        alt="Dr. Lakdawala Eye Hospital"
                        style={{
                          height: "220px",
                          objectFit: "cover",
                          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-6 gallery-right">
                    <div
                      className="single-img wow fadeInRight"
                      data-wow-delay="0.5s"
                    >
                      <img
                        className="animate-float-bob-y"
                        // src={imageUrls["44.jpg"]}
                        src="assets/img/about/44.jpg"
                        style={{
                          height: "340px",
                          objectFit: "cover",
                          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        }}
                        alt="Dr. Lakdawala Eye Hospital"
                      />
                    </div>
                    <div
                      className="single-img wow fadeInLeft"
                      data-wow-delay="0.6s"
                    >
                      <img
                        // src={imageUrls["33.jpeg"]}
                        src="assets/img/about/33.jpeg"
                        alt="Dr. Lakdawala Eye Hospital"
                        style={{
                          height: "220px",
                          objectFit: "cover",
                          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-5 col-lg-6 col-md-8">
              <div className="about-text">
                <div className="section-heading mb-35">
                  <span className="tagline">
                    {t("aboutPage.aboutHospital")}{" "}
                  </span>
                  <h2 className="title">{t("aboutPage.aboutTitle")} </h2>
                  <p> {t("aboutPage.aboutExperience")} </p>
                </div>
                <p>{t("aboutPage.aboutDescription")} </p>

                <button
                  style={{
                    padding: "10px 30px",
                    fontSize: "1rem",
                    backgroundColor: "var(--color-fourth)",
                    color: "#fff",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                    transition: "0.3s",
                    marginTop: "20px",
                    textDecoration: "none",
                    textTransform: "none",
                  }}
                  onClick={scrollToDoctors}
                >
                  {t("aboutPage.aboutDoctor")} <FiChevronsRight />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section style={{ backgroundColor: "var(--color-fourth)" }}>
        <h2
          className="title"
          style={{ color: "white", padding: 50, textAlign: "center" }}
        >
          {t("aboutPage.gallery")}
        </h2>
      </section>
      <PageBanner
        title={t("pageBanner.about")}
        pageName={t("pageBanner.about")}
        pageNumber="3"
      />{" "}
      <div
        style={{
          height: 2,
          backgroundColor: "var(--color-fourth)",
          marginBottom: 240,
        }}
      />
      <div className="wcu-with-doctors">
        <section className="wcu-section section-gap-top">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10">
                <div className="section-heading heading-white text-center mb-40">
                  <span className="tagline">{t("aboutPage.whyChoose")}</span>
                  <h2 className="title">{t("aboutPage.whyChoose2")} </h2>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              {[
                {
                  title: t("aboutPage.box1"),
                  description:
                    "From LASIK and cataract surgeries to glaucoma and retinal treatments, we provide a wide range of specialized ophthalmic care.",
                  img: "assets/img/img-title-box/01.jpg",
                  link: "/services",
                },
                {
                  title: t("aboutPage.box2"),
                  description:
                    "Led by Dr. Imtiaz Lakdawala with over 25 years of expertise, our team of skilled ophthalmologists ensures the best outcomes for every patient.",
                  img: "assets/img/img-title-box/03.jpg",
                  link: "/about",
                },
                {
                  title: t("aboutPage.box3"),
                  description:
                    "Our state-of-the-art equipment and innovative surgical procedures offer precise, efficient, and comfortable treatments.",
                  img: "assets/img/img-title-box/02.jpg",
                  link: "/equipments",
                },
              ].map((item, index) => (
                <Link
                  className="col-lg-4 col-md-6 col-sm-9"
                  key={index}
                  to={item.link}
                >
                  <div
                    className="image-title-box mt-30 wow fadeInUp"
                    data-wow-delay={`${0.3 + index * 0.1}s`}
                  >
                    <h4 className="title">
                      <Link to={item.link}>{item.title}</Link>
                    </h4>
                    <div className="image" style={{ cursor: "pointer" }}>
                      <img src={item.img} alt={item.title} />
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section
          ref={doctorsSectionRef}
          className="doctors-section bg-color-grey polygon-pattern-2"
        >
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-6 col-md-6">
                <div className="section-heading text-center mb-40">
                  <span className="tagline">{t("aboutPage.ourTeam1")}</span>
                  <h2 className="title">{t("aboutPage.ourTeam2")}</h2>
                </div>
              </div>
            </div>
            <div
              className="row justify-content-center doctors-loop"
              style={{ display: "flex" }}
            >
              {users
                .sort((a, b) => {
                  if (a.priority < b.priority) return -1;
                  if (a.priority > b.priority) return 1;
                  return 0;
                })
                .map((doctor, index) => (
                  <div
                    key={index}
                    style={{
                      flex: "1 1 calc(25% - 20px)",
                      minWidth: "300px",
                      maxWidth: "calc(25% - 20px)",
                      display: "flex",
                      flexDirection: "column",
                      marginBottom: "20px",
                    }}
                  >
                    <Link
                      className="doctor-box-three wow fadeInUp"
                      to={`/doctor`}
                      state={{ doctor }}
                      style={{
                        textDecoration: "none",
                        display: "flex",
                        flexDirection: "column",
                        minHeight: "425px",
                        flexGrow: 1,
                        justifyContent: "space-between",
                        cursor: "pointer",
                      }}
                    >
                      <div
                        className="doctor-photo"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "150px",
                          height: "150px",
                          margin: "0 auto",
                        }}
                      >
                        <img
                          src={doctor.thumbnailURL}
                          alt={`Photo of ${getTranslatedValue(
                            doctor.role,
                            i18n.language
                          )}`}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            objectPosition: "center",
                            borderRadius: "50%",
                          }}
                        />
                      </div>
                      <div
                        className="doctor-information"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          flexGrow: 1,
                          marginTop: "20px",
                        }}
                      >
                        <div>
                          <h5 className="name">
                            <Link to={`/doctor`} state={{ doctor }}>
                              {getTranslatedValue(doctor.name, i18n.language)}
                            </Link>
                          </h5>
                          <span className="specialty">
                            {getTranslatedValue(doctor.role, i18n.language)}
                          </span>
                          <p
                            className="experience"
                            style={{ color: "var(--color-body)" }}
                          >
                            {getTranslatedValue(
                              doctor.experience,
                              i18n.language
                            )}
                          </p>
                        </div>
                        {/* Know More Button */}
                        <div
                          className="read-more"
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            background: "var(--color-fourth)",
                            padding: "10px 20px",
                            fontSize: "16px",
                            textAlign: "center",
                            marginTop: "20px",
                            borderRadius: "5px",
                            cursor: "pointer",
                          }}
                        >
                          <Link
                            to={`/doctor`}
                            state={{ doctor }}
                            style={{
                              color: "white",
                              textDecoration: "none",
                              width: "100%",
                              textAlign: "center",
                            }}
                          >
                            {t("home.bannerBoxButton2")}
                          </Link>
                        </div>
                      </div>
                    </Link>
                  </div>
                ))}
            </div>
          </div>
        </section>
      </div>{" "}
      <div ref={reviewsSectionRef}>
        {" "}
        <ReviewsSection />
      </div>
      <section className="faq-section section-gap">
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-lg-6 col-md-10">
              <div className="faq-image text-center text-lg-left mb-md-50">
                <img
                  src="assets/img/section-img/doctor-testing-patient-eyesight_23-2149230013.jpg"
                  alt="Eye checkup, Dr. Lakdawala Eye Hospital"
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-9 col-sm-11">
              <div className="faq-content pl-xl-5">
                <div className="section-heading mb-30">
                  <span className="tagline">{t("aboutPage.howCanWeHelp")}</span>
                  <h2 className="title">{t("aboutPage.howCanWeHelp2")} </h2>
                </div>
                <p>{t("aboutPage.howCanWeHelp3")}</p>
                <Accordion
                  defaultActiveKey="0"
                  className="accordion-style-two mt-30"
                >
                  <Accordion.Item
                    eventKey="1"
                    className={toggle === 1 ? "active-accordion" : ""}
                  >
                    <Accordion.Header
                      onClick={() => setToggle(toggle === 1 ? 0 : 1)}
                    >
                      <span>{t("aboutPage.faq1")}</span>
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>{t("aboutPage.faqa1")}</p>
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item
                    eventKey="2"
                    className={toggle === 2 ? "active-accordion" : ""}
                  >
                    <Accordion.Header
                      onClick={() => setToggle(toggle === 2 ? 0 : 2)}
                    >
                      <span>{t("aboutPage.faq2")}</span>
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>{t("aboutPage.faqa2")}</p>
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item
                    eventKey="3"
                    className={toggle === 3 ? "active-accordion" : ""}
                  >
                    <Accordion.Header
                      onClick={() => setToggle(toggle === 3 ? 0 : 3)}
                    >
                      <span>{t("aboutPage.faq3")}</span>
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>{t("aboutPage.faqa3")}</p>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layouts>
  );
};

export default About;
